import * as Actions from '../../actions/workOrder/types';

const initialState = {
  // get work order

  getWorkOrderLoader: false,
  getWorkOrder: '',
  getWorkOrderError: '',

  // update work order items data

  updateWorkOrderLoader: false,
  updateWorkOrderSuccess: '',
  updateWorkOrderError: '',

  // update work order status

  updateWorkOrderStatusLoader: false,
  updateWorkOrderStatusSuccess: '',
  updateWorkOrderStatusError: '',
};

export default function (state = initialState, action) {
  const updateJobItemMechanic = () => {
    const _getWorkOrder = state.getWorkOrder;
    const _jobId = action.payload?.jobId || '';
    const _jobItemId = action.payload?.jobItemId || '';

    const _foundIndx = _getWorkOrder?.jobs?.findIndex((j) => j.id === _jobId);

    if (_foundIndx > -1) {
      if (_getWorkOrder.jobs[_foundIndx]?.id) {
        if (action.payload?.type === 'all') {
          _getWorkOrder.jobs[_foundIndx].extrasWithJob.items =
            action.payload?.jobItems || [];
          _getWorkOrder.jobs[_foundIndx].jobStatus = 'completed';

          _getWorkOrder.jobs[_foundIndx].jobOverallTime =
            +action.payload?.totalWorkedHrs || 0;
        } else {
          const jobItemIndex = _getWorkOrder.jobs[
            _foundIndx
          ].extrasWithJob.items.findIndex((j) => j.id === _jobItemId);
          if (
            _getWorkOrder.jobs[_foundIndx].extrasWithJob.items[jobItemIndex]?.id
          ) {
            if (action.payload?.type === 'parts_supplies') {
              _getWorkOrder.jobs[_foundIndx].extrasWithJob.items[
                jobItemIndex
              ].status = action.payload?.itemStatus || '';
            } else if (
              action.payload?.type === 'labours' ||
              action.payload?.type === 'updateMechanicTime'
            ) {
              _getWorkOrder.jobs[_foundIndx].extrasWithJob.items[
                jobItemIndex
              ].totalWorkedTime = +action.payload?.totalWorkedTime || 0;

              _getWorkOrder.jobs[_foundIndx].jobOverallTime =
                +action.payload?.totalWorkedHrs || 0;

              _getWorkOrder.jobs[_foundIndx].extrasWithJob.items[
                jobItemIndex
              ].itemMechanics = action.payload?.itemMechanics || [];
            }
          }
        }
      }
    }
    return _getWorkOrder;
  };
  switch (action.type) {
    // Get Work Order data

    case Actions.GET_WORK_ORDER_DATA_REQUEST:
      return {
        ...state,
        getWorkOrderLoader: true,
        getWorkOrder: '',
      };
    case Actions.GET_WORK_ORDER_DATA_SUCCESS:
      return {
        ...state,
        getWorkOrderLoader: false,
        getWorkOrder: action.payload?.data?.ro || '',
      };

    case Actions.GET_WORK_ORDER_DATA_FAIL:
      return {
        ...state,
        getWorkOrderLoader: false,
        getWorkOrderError: action.payload,
      };

    // when declined job is approved/or unAuthorize job
    case Actions.UPDATE_WORK_ORDER_JOB_STATUS:
      const getWorkOrder = state.getWorkOrder;
      const jobId = action.payload?.jobId || '';

      const foundIndx = getWorkOrder?.jobs?.findIndex((j) => j.id === jobId);

      if (foundIndx > -1) {
        getWorkOrder.jobs[foundIndx].isAuthorized =
          action.payload?.isAuthorized || false;
        getWorkOrder.jobs[foundIndx].authorizationStatus =
          action.payload?.authorizationStatus;
      }

      return {
        ...state,
        getWorkOrder: {
          ...getWorkOrder,
        },
      };

    // Update Work Order Items Data

    case Actions.UPDATE_WORK_ORDER_REQUEST:
      return {
        ...state,
        updateWorkOrderLoader: true,
      };
    case Actions.UPDATE_WORK_ORDER_SUCCESS:
      const _getWorkOrder1 = updateJobItemMechanic();

      return {
        ...state,
        getWorkOrder: {
          ..._getWorkOrder1,
        },
        isMarkCompleted: action.payload?.isMarkCompleted || false,
        timerData: action.payload,
        updateWorkOrderLoader: false,
        updateWorkOrderSuccess:
          action.payload?.message || // dont show the toast when user update the notes
          action.payload?.data?.message ||
          'Job Updated Successfully.',
      };

    case Actions.UPDATE_WORK_ORDER_FAIL:
      return {
        ...state,
        updateWorkOrderLoader: false,
        updateWorkOrderError: action.payload,
      };
    case Actions.CLEAR_UPDATE_WORK_ORDER:
      return {
        ...state,
        updateWorkOrderLoader: false,
        updateWorkOrderSuccess: '',
        isMarkCompleted: false,
      };
    // Update Work Order Status

    case Actions.UPDATE_WORK_ORDER_STATUS_REQUEST:
      return {
        ...state,
        updateWorkOrderStatusLoader: true,
      };
    case Actions.UPDATE_WORK_ORDER_STATUS_SUCCESS:
      return {
        ...state,
        getWorkOrder: {
          ...state.getWorkOrder,
          workOrderStatus:
            action.payload?.status ||
            state?.getWorkOrder?.workOrderStatus ||
            '',
        },
        updateWorkOrderStatusLoader: false,
        updateWorkOrderStatusSuccess:
          action.payload?.message || 'Status Updated Successfully.',
      };

    case Actions.UPDATE_WORK_ORDER_STATUS_FAIL:
      return {
        ...state,
        updateWorkOrderStatusLoader: false,
        updateWorkOrderStatusError: action.payload,
      };
    // remove authorization
    case Actions.REMOVE_AUTHURIZATION_REQUEST:
      return {
        ...state,
        loader: true,
        removedAuthorization: '',
      };
    case Actions.REMOVE_AUTHURIZATION_SUCCESS:
      return {
        ...state,
        loader: false,
        removedAuthorization: action.payload?.data || '',
      };

    case Actions.REMOVE_AUTHURIZATION_FAIL:
      return {
        ...state,
        loader: false,
        error: action.payload,
      };

    // Stat Stop Job Timer
    case Actions.START_STOP_JOB_TIMER_REQUEST:
      return {
        ...state,
        timerLoading: true,
      };
    case Actions.START_STOP_JOB_TIMER_SUCCESS:
      const _getWorkOrder2 = updateJobItemMechanic();

      return {
        ...state,
        getWorkOrder: {
          ..._getWorkOrder2,
        },
        timerLoading: false,
        timerData: action.payload || '',
      };

    case Actions.UPDATE_LABOR_ITEM_MECHANIC_TIME_SUCCESS:
      const _getWorkOrder3 = updateJobItemMechanic();

      return {
        ...state,
        getWorkOrder: {
          ..._getWorkOrder3,
        },
        timerData: action.payload,
      };

    case Actions.START_STOP_JOB_TIMER_FAIL:
      return {
        ...state,
        timerLoading: false,
        timerError: action.payload,
      };
    case Actions.CLEAR_START_STOP_JOB_TIMER_STATES:
      return {
        ...state,
        stopTimer: false,
        timerLoading: false,
        timerData: '',
        timerError: '',
      };

    case Actions.CLEAR_REMOVE_WORK_ORDER_AUTHORIZATION_STATES:
      return {
        ...state,
        removedAuthorization: '',
      };

    case Actions.CLEAR_UPDATE_WORK_ORDER_STATES:
      return {
        ...state,
        updateWorkOrderLoader: false,
        updateWorkOrderSuccess: '',
        updateWorkOrderError: '',

        updateWorkOrderStatusLoader: false,
        updateWorkOrderStatusSuccess: '',
        updateWorkOrderStatusError: '',
      };

    case Actions.CLEAR_WORK_ORDER_STATES:
      return {
        ...state,

        getWorkOrderLoader: false,
        getWorkOrder: '',
        getWorkOrderError: '',

        updateWorkOrderLoader: false,
        updateWorkOrderSuccess: '',
        updateWorkOrderError: '',

        updateWorkOrderStatusLoader: false,
        updateWorkOrderStatusSuccess: '',
        updateWorkOrderStatusError: '',
      };

    default:
      return state;
  }
}
